import React from 'react';

class ImageWithSpinner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showImage: false,
    };
  }

  render() {
    const { image, show, imageClassName } = this.props;
    return (
      <div
        className={this.props.wrapperClassName}
        style={{ display: show ? 'block' : 'none' }}
      >
        <img
          src={require('assets/images/loading-simple.gif')}
          className={imageClassName}
          style={{ display: !this.state.showImage && show ? 'block' : 'none' }}
        />
        <img
          src={image}
          className={imageClassName}
          onLoad={this._onLoad}
          style={{ display: this.state.showImage && show ? 'block' : 'none' }}
        />
      </div>
    );
  }

  _onLoad = () => {
    this.setState({
      showImage: true,
    });
  };
}

export default ImageWithSpinner;
